import {ChangeDetectionStrategy, Component, forwardRef} from '@angular/core';
import {NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {OneLineObjectComponent} from './one-line-object.component';

@Component({
  selector: 'app-one-line-checkpoint-control',
  template: `
    <app-checkpoint-list-control
      *transloco="let t; read: 'obj.one-line-checkpoint'"
      [formControl]="objectListControl"
      [label]="t('label')"
      [parentId]="newObjParentId"
      [customStyle]="customStyle"
      [allowAddNew]="allowAddNew"
      [allowDelete]="allowDelete"
      [allowEdit]="allowEdit"
      [maxCount]="1"
      [isLoading]="isLoading"
    >
    </app-checkpoint-list-control>
  `,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => OneLineCheckpointComponent),
      multi: true,
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OneLineCheckpointComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OneLineCheckpointComponent extends OneLineObjectComponent {
  constructor() {
    super();
  }
}
